import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { useNavIntent } from '../../context/NavigationContext';

/**
 * Opens the target of an onboarding step.
 *
 * Two mechanisms, never `window.location`:
 *   - the router for the destination route (`/knowledge`, `/chat`,
 *     `/missions/run/:id`, `/missions/review/:deckId`),
 *   - the nav-intent channel for the payload the destination needs (a file to
 *     select, a question to ask). The intent has to be set BEFORE navigating:
 *     the destination consumes it in its mount effect.
 *
 * Note the route: the pre-Etch panel handed its intents to `/ide`, which now
 * only redirects. Steps address `/knowledge` directly.
 */
export function useStepNavigation() {
  const navigate = useNavigate();
  const { navigate: navWithData } = useNavIntent();

  return useCallback(
    (step) => {
      if (!step?.to) return;
      if (step.intent) navWithData(step.intent.path, step.intent.data);
      navigate(step.to);
    },
    [navigate, navWithData]
  );
}

export default useStepNavigation;
